import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Tooltip as ReactTooltip } from 'react-bootstrap';

class Tooltip extends React.Component {

	render() {
		return (
			<Fragment>
				&nbsp;&nbsp;
				<OverlayTrigger
					placement={this.props.placement}
					trigger="click"
					rootClose={true}
					overlay={
						<ReactTooltip id='tooltip'>
							<div dangerouslySetInnerHTML={{ __html: this.props.tip }} />
						</ReactTooltip>
					}>
					<FontAwesomeIcon icon={faInfoCircle} className="tooltipIcon" />
				</OverlayTrigger>
			</Fragment>
		)
	}
}

export default Tooltip;

Tooltip.defaultProps = {
	placement: "right"
};



// WEBPACK FOOTER //
// ./src/fw/components/tooltip/Tooltip.js